import type { SVGProps } from "react";

export const CheckIcon = ({
  width = "18",
  height = "18",
  strokeWidth = "1.125",
  props,
}: {
  width?: string;
  height?: string;
  strokeWidth?: string;
  props?: SVGProps<SVGSVGElement>;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.75 10.5L6.375 13.125L14.25 4.875"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
